module.exports = __webpack_public_path__ + "static/img/carsi_login.2494797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carsi_login.png
// module id = 6Ef9
// module chunks = 58